var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Projects',{attrs:{"allow-all":_vm.allowAll}})
}
var staticRenderFns = []

export { render, staticRenderFns }